<template>
  <AppView
    nav="left-fixed"
    nav-class="tw-bg-app-white-32 tw-shadow-app"
    padd-bottom
  >

    <template v-slot:nav>
      <h4 class="tw-text-xl tw-leading-6 tw-font-bold tw-uppercase tw-pl-5 tw-pt-6">Stats Menu</h4>

      <transition-group name="new" mode="out-in" appear>
        <template v-if="!loading">
          <div key="menu" class="tw-w-full tw-h-full tw-relative tw-pl-5 print-hidden">
            <!-- select dropdown for superadmin to change the company context -->
            <div
              v-if="isSuperAdmin"
              class="tw-border-b tw--ml-5 tw-pl-5 tw-py-3 tw-mt-8"
            >
              <SelectGroup
                :class="[
                  'tw-mr-5',
                  { '--loading-data': loading }
                ]"
                label="Company"
                name="company"
                nameKey="company"
                placeholder="Company Scope"
                input-classes="tw-text-app-deep-blue tw-bg-app-white-32 tw-text-left"
                v-model="selectedCompany"
                :options="companies"
                :reduce="company => company.id"
                :clearable="false"
                :selected="statsContext.companyContext.toString()"
              />
              <SelectGroup
                :class="[
                  'tw-mr-5',
                  { '--loading-data': loadingCompanyPrograms }
                ]"
                label="Program"
                name="companyProgram"
                nameKey="name"
                placeholder="Program Scope"
                input-classes="tw-text-app-deep-blue tw-bg-app-white-32 tw-text-left"
                v-model="selectedCompanyProgram"
                :options="companyPrograms"
                :reduce="companyProgram => companyProgram.id"
                :clearable="false"
              />
            </div>
            <div v-else class="tw-mt-8 tw-pl-5 tw-py-3 tw-border-b">
              <div class="tw-text-app-deep-blue tw-uppercase tw-mt-8 tw-mb-4">
                <span class="opacity-54 tw-text-xs font-title">Program</span> <br />
                <span class=" tw-text-sm tw-font-bold">{{ activeProgramName }}</span>
              </div>
            </div>

            <ul
              class="app-view-menu-list transition-fast tw-mt-10"
              :key="statsContext.programContext"
            >
              <router-link
                tag="li"
                class="app-view-menu-list__item tw-rounded-l-full tw-py-4 tw-pl-8 tw-w-full tw-cursor-pointer hover:tw-bg-gray-300 transition-fast"
                :to="{ name: 'accStats' }"
              >
                Accounts
              </router-link>
              <router-link
                v-if="!isSelfMentorshipContext()"
                tag="li"
                class="app-view-menu-list__item tw-rounded-l-full tw-py-4 tw-pl-8 tw-w-full tw-cursor-pointer hover:tw-bg-gray-300 transition-fast"
                :to="{ name: 'matStats' }"
              >
                Matches
              </router-link>
              <router-link
                v-if="!isSequentialContext() && !isSelfMentorshipContext()"
                tag="li"
                class="app-view-menu-list__item tw-rounded-l-full tw-py-4 tw-pl-8 tw-w-full tw-cursor-pointer hover:tw-bg-gray-300 transition-fast"
                :to="{ name: 'goaStats' }"
              >
                Goals
              </router-link>
              <router-link
                v-if="isSequentialContext() && !isSelfMentorshipContext()"
                tag="li"
                class="app-view-menu-list__item tw-rounded-l-full tw-py-4 tw-pl-8 tw-w-full tw-cursor-pointer hover:tw-bg-gray-300 transition-fast"
                :to="{ name: 'modStats' }"
              >
                Modules
              </router-link>
              <router-link
                tag="li"
                class="app-view-menu-list__item tw-rounded-l-full tw-py-4 tw-pl-8 tw-w-full tw-cursor-pointer hover:tw-bg-gray-300 transition-fast"
                :to="{ name: 'actLog' }"
              >
                Activity Log
              </router-link>
              <!-- <router-link
                tag="li"
                class="app-view-menu-list__item tw-rounded-l-full tw-py-4 tw-pl-8 tw-w-full tw-cursor-pointer hover:tw-bg-gray-300 transition-fast"
                :to="{ name: 'resStats' }"
              >
                Resources
              </router-link> -->
            </ul>

          </div>

          <div key="report" class="tw-absolute tw-bottom-0 tw-py-6 tw-w-full print-hidden">

            <!-- <div class="tw-flex tw-w-full tw-items-center tw-flex-no-wrap tw-p-6 tw--mb-6 tw-bg-gray-100 tw-pr-2">
              <div class="tw-flex-grow">
                <BaseButton
                  :text="btnText"
                  :disabled="btnDisabled"
                  class="tw-border-none tw-font-bold hover:tw-shadow-app transition-fast tw-bg-app-deep-blue-11 tw-block tw-w-full tw-py-3 tw-px-6"
                  confirm
                  @click="createHTMLReport()"
                />
              </div>

              <div>
                <p class="tw-uppercase tw-text-center tw-text-sm tw-text-gray-500 tw-p-3">PDF</p>
              </div>

            </div> -->
          </div>
        </template>
      </transition-group>
    </template>
    <!-- <canvas id="canvas-pdf"></canvas> -->

    <template v-slot:default="{ recalculate }">
      <template v-if="!loading">
        <template v-if="statsContext.programContext">
          <router-view
            @mounted="recalculate(); btnDisabled = false"
            ref="stat-html"
            :key="`${statsContext.companyContext}-${statsContext.programContext}`"
          ></router-view>
        </template>
        <template v-else>
          <div class="tw-flex tw-justify-center tw-items-center tw-h-full">
            <p class="tw-text-lg">Please select a company and program</p>
          </div>
        </template>
      </template>
    </template>
  </AppView>
</template>

<script>
import SelectGroup from '@/components/SelectGroup.vue';

export default {
  name: 'StatsView',
  components: {
    SelectGroup,
  },
  data() {
    return {
      loading: true,
      loadingCompanyPrograms: false,
      btnText: 'export all stats',
      btnDisabled: true,
      companies: [],
      selectedCompany: undefined,
      selectedCompanyProgram: undefined,
      companyPrograms: [],
    };
  },
  watch: {
    async selectedCompany(val) {
      if (val) {
        this.$store.commit('updateStatsContext', val);
        await this.getCompanyPrograms();
      }
    },
    async selectedCompanyProgram(val) {
      if (val) {
        this.$store.commit('updateProgramStatsContext', val);

        await this.$nextTick();

        const isSequentialProgramContext = this.isSequentialContext();
        this.$store.commit('updateIsSequentialProgramStatsContext', isSequentialProgramContext);

        const isSelfMentorshipProgramContext = this.isSelfMentorshipContext();
        this.$store.commit('updateIsSelfMentorshipProgramStatsContext', isSelfMentorshipProgramContext);
      }
    },
  },
  computed: {
    statsContext() {
      return {
        companyContext: this.$store.getters.statsContextId,
        programContext: this.$store.getters.statsProgramContextId,
        regionContext: this.$store.getters.statsRegionContextId,
      };
    },
    activeProgramName() {
      return this.$store.state.CompanyPrograms.ProgramContext.activeProgram.name;
    },
  },
  methods: {
    async getCompanies() {
      this.companies = (await this.$store.dispatch('getCompanies') || []);
    },
    async getCompanyPrograms() {
      if (this.isSuperAdmin) {
        this.loadingCompanyPrograms = true;
        await this.$nextTick();

        const companyPrograms = await this.$store.dispatch('getCompanyPrograms', [this.statsContext.companyContext]);

        if (Array.isArray(companyPrograms)) {
          this.companyPrograms = companyPrograms;
          // this.$store.commit('setResourceProgramContext', companyPrograms[0].id);
        }

        await this.$nextTick();

        this.loadingCompanyPrograms = false;
      }
    },
    isSequentialContext() {
      const sequentialProgramType = this.$store.state.CompanyPrograms.ProgramContext.programTypes.sequential;

      if (this.isSuperAdmin) {
        // eslint-disable-next-line eqeqeq
        const selectedProgram = this.companyPrograms.find((prog) => prog.id == this.statsContext.programContext);
        // eslint-disable-next-line eqeqeq
        return selectedProgram?.type == sequentialProgramType;
      }
      // eslint-disable-next-line eqeqeq
      return this.$store.state.CompanyPrograms.ProgramContext.activeProgram?.type == sequentialProgramType;
    },
    isSelfMentorshipContext() {
      const selfMentorshipProgramType = this.$store.state.CompanyPrograms.ProgramContext.programTypes.selfMentorship;

      if (this.isSuperAdmin) {
        return this.companyPrograms.find((prog) => prog.id == this.statsContext.programContext)?.type == selfMentorshipProgramType;
      }
      return this.$store.state.CompanyPrograms.ProgramContext.activeProgram?.type == selfMentorshipProgramType;
    },
  },
  async created() {
    await this.$nextTick();
    await this.$nextTick();
    await this.$nextTick();

    if (this.isSuperAdmin) {
      await this.getCompanies();
    } else {
      await this.getCompanyPrograms();

      this.$store.commit('updateStatsContext', this.$store.getters.userCompanyId);
      this.$store.commit('updateProgramStatsContext', this.$store.getters.userCompanyProgramId);

      await this.$nextTick();

      const isSequentialProgramContext = this.isSequentialContext();
      this.$store.commit('updateIsSequentialProgramStatsContext', isSequentialProgramContext);
    }

    await this.$nextTick();

    this.loading = false;

    // route to default route
    if (this.$route.name === 'stats') {
      this.$router.push({
        name: 'accStats',
      });
    }
  },
};
</script>

<style>

</style>
